import React from 'react'

export default function Navbar() {
  return (
    <nav className='header'>
      <h1>the office quotes.</h1>
    </nav>
  )
}
